import { render, staticRenderFns } from "./servicedutysetting.vue?vue&type=template&id=edc9b196"
import script from "./servicedutysetting.vue?vue&type=script&lang=js"
export * from "./servicedutysetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports